import { render, staticRenderFns } from "./outgoing-mail.vue?vue&type=template&id=5f2bd484&"
import script from "./outgoing-mail.vue?vue&type=script&lang=js&"
export * from "./outgoing-mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports